import { render, staticRenderFns } from "./PurchaseNew_Details.vue?vue&type=template&id=6b03909c&"
import script from "./PurchaseNew_Details.vue?vue&type=script&lang=js&"
export * from "./PurchaseNew_Details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports